import { getReviewStatusFeatureFlag } from '@dispatch/shared/services';
import { useQuery as useReactQuery } from 'react-query';

/**
 * useReviewStatusFeatureFlag - boolean tenant flag fetched via the
 * configuration endpoint. Defaults to false while loading or on error.
 */
export const useReviewStatusFeatureFlag = (tenantId?: string): boolean => {
  const { data } = useReactQuery<boolean>(
    ['review-status-enabled', tenantId],
    () => getReviewStatusFeatureFlag(tenantId as string),
    {
      enabled: !!tenantId,
      staleTime: 5 * 60 * 1000,
    }
  );
  return data === true;
};
